import React from "react";

const TimingCard = ({
  trackedTime,
  formatTime,
  formatDuration,
  isOnBreak,
  isClockedIn,
  totalBreakTime,
  onClockInClick,
  onBreakClick,
  isSyncing = false,
  className = "",
}) => {
  return (
    <div
      className={`bg-white rounded-xl p-5 shadow-sm border border-indigo-200 hover:shadow-md transition-shadow ${className}`}
    >
      <div className="flex items-center gap-3 mb-5">
        <div className="w-1 h-5 bg-indigo-300 rounded-full" />
        <h3 className="text-indigo-800 font-bold text-base">Your Timing</h3>
      </div>

      <div className="grid grid-cols-2 gap-3 mb-5">
        <div className="bg-emerald-50/50 rounded-xl p-4 text-center border border-emerald-100 hover:border-emerald-200 transition-colors">
          <p className="text-emerald-600 font-semibold text-xs uppercase tracking-wider mb-1">
            Live Tracking
          </p>
          <p className="text-slate-800 text-xl font-semibold">
            {isSyncing ? (
              <span className="inline-flex items-center gap-1.5 text-slate-500">
                <span className="inline-block w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
                Syncing...
              </span>
            ) : (
              formatDuration(trackedTime)
            )}
          </p>
        </div>

        <div className="bg-red-50/50 rounded-xl p-4 text-center border border-red-100 hover:border-red-200 transition-colors">
          <p className="text-red-500 font-semibold text-xs uppercase tracking-wider mb-1">
            Break Time
          </p>
          <p className="text-slate-800 text-xl font-semibold">
            {formatDuration(totalBreakTime)}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <button
          type="button"
          onClick={onBreakClick}
          disabled={!isClockedIn}
          className={`py-3 px-4 rounded-xl font-semibold transition-all duration-200 active:scale-95 ${
            isOnBreak
              ? "bg-red-50 text-red-600 border border-red-200 hover:bg-red-100"
              : "bg-white text-slate-700 border border-indigo-100 hover:border-indigo-200 hover:bg-indigo-50"
          } ${!isClockedIn ? "opacity-40 cursor-not-allowed active:scale-100" : ""}`}
        >
          {isOnBreak ? "End Break" : "Take Break"}
        </button>

        <button
          type="button"
          onClick={onClockInClick}
          disabled={isOnBreak}
          className={`py-3 px-4 rounded-xl font-bold text-white transition-all duration-200 shadow-sm hover:shadow-md active:scale-95 ${
            isClockedIn
              ? "bg-red-600 hover:bg-red-700"
              : "bg-indigo-600 hover:bg-indigo-700"
          } ${isOnBreak ? "opacity-50 cursor-not-allowed active:scale-100" : ""}`}
        >
          {isClockedIn ? "Clock Out" : "Clock In"}
        </button>
      </div>
    </div>
  );
};

export default TimingCard;
